import React from 'react';
import { Sparkles } from 'lucide-react';
import { ICON_PX } from '../ui/lib/iconSizes';

export function ChatSuggestions({ questions, onSelect }) {
  if (!questions?.length) return null;

  return (
    <div className="space-y-1.5">
      <p className="text-caption text-text-muted flex items-center gap-1">
        <Sparkles size={ICON_PX.sm} className="text-aqua" />
        Suggested questions
      </p>
      {questions.map((q, i) => (
        <button
          key={i}
          onClick={() => onSelect(q)}
          className="block w-full text-left px-3 py-1.5 text-body-sm text-text-dark
                     bg-surface-warm hover:bg-aqua/10 rounded border border-nn-border
                     transition-colors truncate"
        >
          {q}
        </button>
      ))}
    </div>
  );
}
